export const strings = {
    admin: {
        backToCompanies: "Back to Companies",
        cancelInvitation: "Cancel",
        cancelInviteSuccess: "Invitation cancelled",
        cancelInviteTitle: "Cancel Invitation",
        cancelledAt: "Cancelled",
        companiesTitle: "Companies",
        confirmCancelInvitation: "Are you sure you want to cancel this invitation?",
        confirmDeleteCompany: "This will permanently remove the company. This action cannot be undone.",
        confirmDisableCompany: "The company will lose access until you enable it again. Continue?",
        confirmEnableCompany: "The company will regain access. Continue?",
        deleteCompany: "Delete",
        deleteCompanySuccess: "Company deleted",
        deleteCompanyTitle: "Delete Company",
        disableCompany: "Disable",
        disableCompanySuccess: "Company disabled",
        disableCompanyTitle: "Disable Company",
        emptyCompanies: "No companies match your filters.",
        emptyInvitations: "No invitations match your filters.",
        emptyResults: "No results recorded yet for this user.",
        enableCompany: "Enable",
        enableCompanySuccess: "Company enabled",
        enableCompanyTitle: "Enable Company",
        examCode: "Exam Code",
        filterAccepted: "Accepted",
        filterAll: "All",
        filterCancelled: "Cancelled",
        filterDisabled: "Disabled",
        filterEnabled: "Enabled",
        filterExpired: "Expired",
        filterPending: "Pending",
        invitationStatus: "Status",
        invitationsTitle: "Invitations",
        invitedAt: "Invited",
        loading: "Loading…",
        resultsTitle: "Exam Results",
        searchPlaceholder: "Search by name, email, company…",
        sendInviteDescription: "Invite a new company to register and take the assessment.",
        sendInviteEmailLabel: "Email",
        sendInviteEmailPlaceholder: "Enter company email",
        sendInviteSubmit: "Send Invite",
        sendInviteSuccess: "Invitation sent",
        sendInviteTitle: "Send Invite",
        statusDisabled: "Disabled",
        statusEnabled: "Enabled",
        viewCompany: "View",
    },
    auth: {
        authorizationHeader: "Authorization",
        bearerPrefix: "Bearer ",
        tokenKey: "auth_token",
    },
    buttonTypes: {
        button: "button",
        submit: "submit",
    },
    code: {
        buttonConfirm: "Confirm",
        buttonLoading: "Loading...",
        buttonReenter: "Re-Enter",
        codeLength: "Code must be exactly 8 characters",
        defaultUserName: "User",
        errorDefault: "An error occurred",
        errorSubtitle: "Re-Enter the Code Again",
        inputPlaceholder: "Enter code..",
        languageArabic: "عربي",
        languageEnglish: "English",
        selectLanguage: "Select language",
        titleCode: "Code",
        titleEnter: "Enter the Job Bar Assessment code",
        titleIncorrect: "Incorrect",
        titleLoading: "Loading...",
        titleSuffix: "to view the generated results",
    },
    common: {
        cancel: "Cancel",
        closeAlert: "Close alert",
        confirm: "Confirm",
        copied: "Copied",
        copy: "Copy",
        decorativeStar: "Decorative star",
        invalid: "invalid",
        languageAr: "AR",
        languageEn: "EN",
        loading: "Loading...",
        loggingOut: "Logging out...",
        logout: "Log out",
        notFound: "not found",
        save: "Save",
        switchToArabic: "Switch to Arabic",
        switchToEnglish: "Switch to English",
    },
    companyName: "Twindix Global Inc.",
    cookie: {
        expiredDate: "=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/",
        expiresPrefix: ";expires=",
        pathSuffix: ";path=/;SameSite=Strict",
    },
    css: {
        overflowHidden: "hidden",
        overflowUnset: "unset",
    },
    dateFormat: {
        day: "numeric",
        month: "short",
        year: "numeric",
    },
    debug: {
        loginFailed: "Login failed:",
        logoutFailed: "Logout failed:",
        storageSaveFailed: "Failed to save to localStorage",
    },
    errors: {
        checkInput: "Please check your input",
        examNotFound: "Exam not found",
        genericError: "An error occurred",
        invalidCredentials: "Invalid credentials",
        invalidExamCode: "Invalid exam code",
        invalidJobId: "Invalid job ID",
        jobNotFound: "Job not found",
        processingFailed: "Processing failed",
        tryAgain: "An error occurred. Please try again.",
    },
    forgotPassword: {
        backToLogin: "Back to Login",
        description: "Enter your email address and we'll send you a link to reset your password.",
        emailLabel: "Email Address",
        emailPlaceholder: "Enter your email",
        sidebarDescription: "No worries! Enter your email address and we'll send you a secure link to reset your password and regain access to your account.",
        sidebarTitle: "Forgot Your Password?",
        submitButton: "Send Reset Link",
        successMessage: "If an account exists with this email, you will receive a password reset link.",
        title: "Forgot Password",
    },
    inputTypes: {
        password: "password",
        text: "text",
    },
    invite: {
        invitePrefix: "Invitation sent to ",
        roleAll: "all",
        successFallback: "Invitation sent successfully.",
    },
    login: {
        description: "Welcome back, please enter the details for your account",
        emailLabel: "E-mail",
        emailPlaceholder: "Enter E-mail here",
        forgotPassword: "Forget your password?",
        forgotPasswordLink: "Click here",
        passwordLabel: "Password",
        passwordPlaceholder: "Enter Password here",
        sidebarDescription: "Accurate recommendations for suitable career paths, along with practical steps to help both the student and the job seeker to make a confident, decisive choice.",
        sidebarTitle: "Welcome Back to Twindix",
        submitButton: "Login",
        title: "Login",
    },
    logoutModal: {
        cancel: "Cancel",
        confirmMessage: "Are you sure you want Log out",
        logoutButton: "Log out",
    },
    notFound: {
        backToHome: "Back to Home",
        description: "Oops! The page you are looking for does not exist or has been moved.",
        subtitle: "Page Not Found",
        title: "404",
    },
    profile: {
        assessmentBannerDescription: "Enter your Job Bar Assessment code to get personalized career and academic recommendations.",
        assessmentBannerTitle: "Ready to start your assessment?",
        backToCode: "Back to Code Entry",
        cancelEdit: "Cancel",
        companyLabel: "Company",
        confirmPasswordLabel: "Confirm New Password",
        confirmPasswordPlaceholder: "Re-enter new password",
        editButton: "Edit Profile",
        emailLabel: "Email",
        nameLabel: "Name",
        newPasswordLabel: "New Password",
        newPasswordPlaceholder: "Leave empty to keep current",
        notAvailable: "N/A",
        passwordMismatch: "Passwords do not match.",
        passwordSectionDescription: "Optional. Fill both fields to change your password.",
        passwordSectionTitle: "Change Password",
        phoneLabel: "Phone",
        roleAdmin: "Administrator",
        roleCompany: "Company",
        roleLabel: "Role",
        saveButton: "Save Changes",
        startAssessment: "Start Assessment",
        title: "Profile",
        updateError: "Failed to update profile",
        updateSuccess: "Profile updated successfully",
    },
    profileNav: {
        companies: "Companies",
        invitations: "Invitations",
        navTitle: "Account",
        profile: "Profile",
        sendInvite: "Send Invite",
    },
    queryParams: {
        code: "code",
        email: "email",
        jobId: "jobId",
        lang: "lang",
        returnUrl: "returnUrl",
        token: "token",
    },
    register: {
        backToLogin: "Back to Login",
        companyNameLabel: "Company Name",
        companyNamePlaceholder: "Enter your company name",
        confirmPasswordLabel: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm your password",
        description: "Welcome to Twindix Academic Finder. Please enter your account details to complete your registration.",
        emailLabel: "Email Address",
        emailPlaceholder: "Enter your email",
        goToLogin: "Go to Login",
        invalidToken: "Invalid or expired invitation link.",
        nameLabel: "Full Name",
        namePlaceholder: "Enter your full name",
        passwordLabel: "Password",
        passwordMismatch: "Passwords do not match.",
        passwordPlaceholder: "Enter your password",
        phoneLabel: "Phone Number",
        phonePlaceholder: "Enter your phone number",
        sidebarDescription: "Create your account to access personalized academic and career recommendations. Our platform helps students and parents make informed decisions about their educational journey.",
        sidebarTitle: "Join Twindix Academic Finder",
        submitButton: "Register",
        successMessage: "Registration completed successfully!",
        title: "Register",
    },
    resetPassword: {
        backToLogin: "Back to Login",
        confirmPasswordLabel: "Confirm Password",
        confirmPasswordPlaceholder: "Confirm new password",
        description: "Enter your new password below.",
        goToLogin: "Go to Login",
        invalidLink: "Invalid or expired reset link.",
        passwordLabel: "New Password",
        passwordMismatch: "Passwords do not match.",
        passwordPlaceholder: "Enter new password",
        sidebarDescription: "Choose a strong password to secure your account. Make sure it's at least 6 characters and includes a mix of letters and numbers.",
        sidebarTitle: "Create New Password",
        submitButton: "Reset Password",
        successMessage: "Your password has been reset successfully.",
        title: "Reset Password",
    },
    result: {
        buttonReset: "Reset",
        copiedMessage: "Copied to clipboard!",
        loading: "Loading...",
        pdfButton: "Download PDF",
        pdfCodeLabelAr: "الرمز",
        pdfCodeLabelEn: "Code",
        pdfDocLabelAr: "تقرير التوصيات",
        pdfDocLabelEn: "Recommendations Report",
        pdfFileNamePrefix: "career-recommendations",
        pdfIssuedLabelAr: "تاريخ الإصدار",
        pdfIssuedLabelEn: "Issued",
        pdfRecipientLabelAr: "المرشح",
        pdfRecipientLabelEn: "Prepared for",
        pdfTitleAr: "التوصيات المهنية",
        pdfTitleEn: "Career Recommendations",
        selectedLanguage: "Selected Language",
    },
    validation: {
        codeMinLength: "Code must be at least 3 characters",
        codeRequired: "Please enter a code",
        companyNameRequired: "Company name is required",
        emailInvalid: "Please enter a valid email address",
        emailRequired: "Email is required",
        nameRequired: "Name is required",
        passwordMinLength: "Password must be at least 6 characters",
        passwordNeedsLetter: "Password must contain at least one letter",
        passwordNeedsNumber: "Password must contain at least one number",
        passwordRequired: "Password is required",
        phoneInvalid: "Please enter a valid phone number",
        phoneRequired: "Phone number is required",
    },
} as const;
